import { Anchor } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9645c0b6-481f-4d07-81fb-c2ea43b51b14/artifacts/rw309x94_VoidWolves2-Photoroom.png";

export const Footer = () => {
    return (
        <footer className="bg-black border-t border-white/10 py-12" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    {/* Logo and tagline */}
                    <div className="flex items-center gap-4">
                        <img 
                            src={LOGO_URL} 
                            alt="Voidwolves" 
                            className="h-12 w-auto opacity-60"
                        />
                        <div>
                            <span className="font-heading font-bold text-white text-sm">VOIDWOLVES</span>
                            <p className="font-mono text-[10px] text-gray-500 tracking-[0.1em]">
                                126TH CARRIER STRIKE GROUP
                            </p>
                        </div>
                    </div>

                    {/* Tagline */}
                    <p className="font-mono text-xs text-gray-600 tracking-wider">
                        THE VOID PROVIDES. THE PACK ENDURES.
                    </p>

                    {/* Copyright */}
                    <div className="text-center md:text-right">
                        <p className="font-mono text-[10px] text-gray-600 tracking-wider">
                            TACTICAL COMMAND INTERFACE v4.126
                        </p>
                        <p className="font-mono text-[10px] text-gray-700 mt-1">
                            STAR CITIZEN ORG | EST. 2954
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};
